import { emeraldMainnetTokens } from "constants/tokens";

export default function useTokens() {
  return emeraldMainnetTokens;
}
